import * as e from "react";
import { forwardRef as o } from "react";
const i = o(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M8.5 17L10.5 20L10 22.5M8.5 17L7.5 20L5.5 22.5M8.5 17L8 13.5L8.38871 11.1678C8.44401 10.8359 8.80462 10.6523 9.10551 10.8028L11.5 12H14",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 2.04
        }
      ),
      /* @__PURE__ */ e.createElement(
        "circle",
        {
          cx: 10.0357,
          cy: 8.03571,
          fill: "#000",
          r: 2.23571,
          stroke: "#ECECEC",
          strokeWidth: 0.4
        }
      ),
      /* @__PURE__ */ e.createElement(
        "line",
        {
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.5,
          x1: 16.25,
          x2: 18.75,
          y1: 10.75,
          y2: 10.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "line",
        {
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.5,
          x1: 13.25,
          x2: 18.75,
          y1: 13.75,
          y2: 13.75
        }
      ),
      /* @__PURE__ */ e.createElement("circle", { cx: 21.0357, cy: 12.0357, fill: "#000", r: 2.03571 })
    );
  }
);
export {
  i as BetBuilderBadgeBasketballAssist
};
